import { useTranslation } from 'react-i18next';
import type { Folder, Project } from '../../lib/api';
import { MenuButton, useFolderMenu, useProjectMenu } from './ItemMenu';

/** Project header menu (P16-4: the same items as the project card's right-click menu). */
export function ProjectActions({ project }: { project: Project }) {
  const { t } = useTranslation();
  const menu = useProjectMenu(project);
  return (
    <>
      <MenuButton menu={menu} triggerLabel={t('dashboard.projectActions')} />
      {menu.dialogs}
    </>
  );
}

/** Folder menu: rename, delete after a confirmation. */
export function FolderActions({ folder }: { folder: Folder }) {
  const { t } = useTranslation();
  const menu = useFolderMenu(folder);
  return (
    <>
      <MenuButton menu={menu} triggerLabel={t('dashboard.folderActions')} />
      {menu.dialogs}
    </>
  );
}
